var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    "aria-labelledby": "filterIcon filterDesc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M5.708 10.02c1.026 0 1.895.675 2.187 1.605h6.75a.687.687 0 110 1.375h-6.75a2.293 2.293 0 01-4.373 0H1.354a.687.687 0 110-1.375h2.168a2.293 2.293 0 012.186-1.604zm0 1.376a.917.917 0 100 1.833.917.917 0 000-1.833zm5.5-6.188c1.026 0 1.895.675 2.187 1.604h1.25a.687.687 0 110 1.375l-1.25.001a2.293 2.293 0 01-4.373 0H1.354a.687.687 0 110-1.376h7.668a2.293 2.293 0 012.186-1.604zm0 1.375a.917.917 0 100 1.834.917.917 0 000-1.834zM4.792.396C5.818.396 6.686 1.07 6.978 2h7.668a.687.687 0 110 1.375H6.978a2.293 2.293 0 01-4.373 0h-1.25a.687.687 0 110-1.375h1.25A2.293 2.293 0 014.792.396zm0 1.375a.917.917 0 100 1.833.917.917 0 000-1.833z"
  })));
}

export default SvgFilter;